import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { Button, makeStyles, CircularProgress } from '@material-ui/core'

import useTransfer from 'commons/useTransfer'
import MessageAlert from 'app/components/MessageAlert'
import { STATUS_CANCELED } from 'commons/useTransfer'

const useStyles = makeStyles((theme) => ({
  root: {
    '&.MuiButtonBase-root.Mui-disabled': {
      color: `${theme.colors['grey-200']} !important`,
    },
  },
}))

const CancelTransfer = (props) => {
  const { id, transferId } = props

  const classes = useStyles()
  const { formatMessage } = useIntl()
  const { createStatusButton } = useTransfer()

  const [cancelLoading, cancel] = createStatusButton(
    transferId,
    STATUS_CANCELED,
  )
  const [isLoading, setIsLoading] = useState(cancelLoading)

  const handleSubmit = async () => {
    try {
      await cancel(id)
      setTimeout(() => {}, 2000)
    } catch (error) {
      MessageAlert.showNetworkError(formatMessage)(error)
    }
  }

  useEffect(() => {
    if (cancelLoading) setIsLoading(cancelLoading)
    else {
      setTimeout(() => {
        setIsLoading(false)
      }, 2000)
    }
  }, [cancelLoading])

  return (
    <Button
      className={clsx(
        classes.root,
        'text-14 text-primary normal-case p-0 hover:bg-transparent',
      )}
      onClick={handleSubmit}
      disabled={isLoading}
    >
      {formatMessage({
        id: 'teamMembers.cancel.transfer.label',
      })}
      {isLoading && (
        <CircularProgress
          size={14}
          style={{ color: '#A8A8A8', margin: '0 1rem' }}
        />
      )}
    </Button>
  )
}

CancelTransfer.propTypes = {
  id: PropTypes.number,
  transferId: PropTypes.number,
}

export default CancelTransfer
